<template>
  <div class="badge-list">
    <BadgeListItem
      v-for="item in items"
      :key="item.text"
      :text="item.text"
      :color="item.color"
      :children="item.children"
    />
  </div>
</template>
<script lang="ts" setup>
import BadgeListItem from '../atoms/BadgeListItem.vue'
type BadgeItemProps = {
  text: string
  color?: string
  children?: BadgeItemProps[]
}
type BadgeListProps = {
  items: BadgeItemProps[]
}
defineProps<BadgeListProps>()
</script>
<style lang="scss" scoped>
@use '@/design-system/design-tokens/font-mixins.scss';
@use '@/design-system/design-tokens/variables.scss';
.badge-list {
  display: flex;
  flex-direction: row;
  min-height: calc(16px + 4px + 4px);
  margin: 0;
  padding: 0;
  gap: 5px;
  flex-wrap: wrap;
  align-items: center;
  list-style: none;
}
.vertical-separator {
  display: inline-block;
  height: 16px;
  width: 1px;
  margin-left: 5px;
  background-color: variables.$color-graph-gray;
  transform: translateY(4px);
}
</style>
